module.exports = __webpack_public_path__ + "static/media/chatDani.54505372.svg";